import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AppShell } from "../components/Nav";
import { getToken } from "../lib/auth";

export default function CompatibilityBreakdown() {
  const [loading, setLoading] = useState(true);
  const [match, setMatch] = useState(null);

  useEffect(() => {
    const token = getToken();

    fetch("/api/journey/match", {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.ok ? res.json() : null)
      .then(data => {
        setMatch(data);
        setLoading(false);
      })
      .catch(() => {
        setMatch(null);
        setLoading(false);
      });
  }, []);

  return (
    <AppShell>
      <div className="px-6 md:px-12 py-10 md:py-14">

        <h1 className="font-display text-4xl md:text-5xl mb-6">
          Compatibility
        </h1>

        {loading && (
          <div className="text-white/60">Loading compatibility…</div>
        )}

        {!loading && !match && (
          <div className="glass rounded-2xl p-8 text-center">
            <h2 className="text-xl mb-3">Your match will be revealed</h2>
            <p className="text-white/60 mb-6">
              once you complete your journey.
            </p>
            <Link
              to="/round"
              className="rounded-full bg-gradient-gold px-6 py-3 text-black font-semibold"
            >
              Continue your journey →
            </Link>
          </div>
        )}

        {!loading && match && (
          <div className="glass rounded-2xl p-8 text-center">
            <h2 className="text-xl mb-3">
              {match.name || "Your match"}
            </h2>
            <p className="text-white/60 mb-6">
              Compatibility insights available.
            </p>
            <Link
              to="/chat"
              className="rounded-full border border-white/20 px-6 py-3"
            >
              Go to conversation →
            </Link>
          </div>
        )}

      </div>
    </AppShell>
  );
}
